/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Job Status Icon component.
 */
export const JobStatusIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d="M13 8.99997H22M13 17H22M2 7.45997L5.54 11L11.18 5.33997M2 15.46L5.54 19L11.18 13.34" stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap="round" />
    </svg>);
};
